import React, { createContext, RefObject, useContext } from "react";

interface WidgetContentContextType {
    widgetContentRef: RefObject<HTMLDivElement> | null;
}

const WidgetContentContext = createContext<WidgetContentContextType>({ widgetContentRef: null });

export const useWidgetContent = () => {
    const context = useContext(WidgetContentContext);
    if (!context) {
        throw new Error("useWidgetContent must be used within a WidgetContentProvider");
    }
    return context;
};

interface WidgetContentProviderProps {
    children: React.ReactNode;
    widgetContentRef: RefObject<HTMLDivElement>;
}

export const WidgetContentProvider: React.FC<WidgetContentProviderProps> = ({ children, widgetContentRef }) => (
    <WidgetContentContext.Provider value={{ widgetContentRef }}>{children}</WidgetContentContext.Provider>
);
